// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTreeItem.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTreeItem component
 */
!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');

  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');
  var constants = require('logic/data/Izenda.ConnectionConstants');

  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  const { has, some, cond, matches, constant, isNil, filter } = require('lodash/fp');
  var DataSourceTreeItem = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      node: React.PropTypes.object.isRequired,
      filter: React.PropTypes.string,
      showSelected: React.PropTypes.bool,
      toggleIcon: React.PropTypes.element
    },
    render: function() {
      var node = this.props.node;
      var dataSource = node.dataSource;
      var filterString = this.props.filter;
      var showSelected = this.props.showSelected;
      var toggleIcon = this.props.toggleIcon;

      var containerClasses = classnames({
        'disabled-elm': isEmptyGroup(node)
      });
      var textClasses = classnames('u_curPointer', {
        'tree-item': !node.isTypeGroup()
      });
      var childCount = node.childCount(function(child) {
        return !has('selected', child.dataSource) || child.dataSource.selected === showSelected;
      });

      function isEmptyGroup(node) {
        return node.isTypeGroup() && childCount === 0;
      }

      function showNumChildren(node, count) {
        if (node.isTypeGroup() && node.childNodes) {
          return <span> ({count})</span>;
        }
        return null;
      }

      // function showToggleTriangle (node) {
      //   if (node.isTypeGroup && childCount > 0) {
      //    return (<i
      //     className='icon-toggle-triangle'
      //     onClick={toggle} />)
      //   }
      //   return null;
      // }

      return (
        <div className={containerClasses} key={node.id}>
          <label
            className={textClasses}
            key={node.id}
            disabled={isEmptyGroup(node) ? 'disabled' : null}
            onClick={this.onClick}
          >
            <TextHighLight highlight={filterString} text={node.name} />
            {showNumChildren(node, childCount)}
            {renderChangesIcon(node, childCount)}
          </label>
          {toggleIcon}
        </div>
      );

      /**
       * Render changes icon for data sources
       * @param  {QuerySourceNode} node
       * @param  {Number} childCount Child Nodes count
       */
      function renderChangesIcon(node, childCount) {
        var hasChangesIcon = '';

        // render changes icon for TypeGroup (Table/View/SP/Function) level
        if (node.isTypeGroup() && node.childNodes) {
          hasChangesIcon =
            filterPhysicalChanges(node).length > 0 ? (
              <span className='icon-attention warning-color' title={constants.DATA_SOURCE_CHANGES} />
            ) : (
              ''
            );
        } else if (childCount > 0) {
          // render changes icon for DB level
          var change = some(function(type) {
            return filterPhysicalChanges(type).length > 0;
          }, node.childNodes);

          if (change) {
            hasChangesIcon = <span className='icon-attention warning-color' title={constants.DATA_SOURCE_CHANGES} />;
          }
        } else {
          hasChangesIcon = renderChangesIconForField(node);
        }
        return hasChangesIcon;
      }

      /**
       * render changes icon for field level
       * @param  {QuerySourceNode} node
       */
      function renderChangesIconForField(node) {
        var isNew = checkChangedStatus(node.approval, node.change, constants.DETECTED_CHANGE_LEVEL.ADDED);
        var isEdit = checkChangedStatus(node.approval, node.change, constants.DETECTED_CHANGE_LEVEL.MODIFIED);
        var isDelete = checkChangedStatus(node.approval, node.change, constants.DETECTED_CHANGE_LEVEL.DELETED);

        var className = classnames({
          'icon-fields success-color': isNew,
          'icon-attention warning-color': isEdit,
          'icon-fields fail-color': isDelete
        });

        var title = cond([
          [matches({ isNew: true }), constant(constants.NEW_DATA_SOURCE)],
          [matches({ isEdit: true }), constant(constants.DATA_SOURCE_CHANGES)],
          [matches({ isDelete: true }), constant(constants.DELETED_DATA_SOURCE)]
        ])({ isNew: isNew, isEdit: isEdit, isDelete: isDelete });

        return <span className={className} title={title} />;
      }

      /**
       * filter physical changes base on approval/change/selected
       * @param  {QuerySourceNode} node
       */
      function filterPhysicalChanges(node) {
        return filter(function(o) {
          return (
            (isNil(o.approval) || o.approval < 1) &&
            (o.change && o.change !== constants.DETECTED_CHANGE_LEVEL.NONE) &&
            o.selected == showSelected
          );
        }, node.childNodes);
      }

      function checkChangedStatus(approval, change, changeLevel) {
        return (isNil(approval) || approval < 1) && change === changeLevel;
      }
    },

    /**
     * Handle toggle selection of a query source.
     * @param  {Object} e React-event object
     */
    onClick: function(e) {
      var props = this.props;
      var item = props.store.item;
      var localization = props.localization;
      var confirmFn = props.confirmFn;
      var showSelected = props.showSelected;
      var node = props.node;
      var dataSource = node.dataSource;

      var toggleSelected = function() {
        if (node.toggleSelect(showSelected)) {
          item.markDirty();
          item.markAvailableDataSourceChange();
        }
      };

      if (dataSource.group) {
        var needMessagePopup = some(
          {
            selected: showSelected,
            disabled: true
          },
          dataSource.querySources
        );
        needMessagePopup
          ? confirmFn('Confirmation', {
              description: localization.getText('CONNECTION_CAN_NOT_MOVE_CUSTOM_VIEW'),
              showCancel: false
            }).then(toggleSelected)
          : toggleSelected();
      } else if (dataSource.disabled) {
        confirmFn('Information', {
          type: 'error',
          description: localization.getText('CONNECTION_CAN_NOT_MOVE_CUSTOM_VIEW'),
          showCancel: false,
          showCloseIndicator: true
        });
      } else {
        toggleSelected();
      }
    }
  });

  module.exports = connect()(DataSourceTreeItem);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionConfig/DataSourceTree/Izenda.DataSourceTreeItem.jsx